import { render, staticRenderFns } from "./InvoiceRejectModal.vue?vue&type=template&id=6f36e12d&scoped=true"
import script from "./InvoiceRejectModal.vue?vue&type=script&lang=js"
export * from "./InvoiceRejectModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRejectModal.vue?vue&type=style&index=0&id=6f36e12d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f36e12d",
  null
  
)

export default component.exports